<template>
  <main class="Wrapper">
    <div v-if="articleIsErrored" class="ServerInfo">
      Sorry, some error happened :(
    </div>
    <BaseArticle
      v-if="!articleIsLoading && !articleIsErrored"
      :key="article.id"
      :className="'Article--full'"
      :id="article.id"
      :timestamp="article.timestamp"
      :author="article.user.name"
      :title="article.title"
      :text="article.text"
      :likeCount="article.likeCount"
      :dislikeCount="article.dislikeCount"
      :commentCount="article.commentCount"
      :viewCount="article.viewCount"
      :tags="article.tags"
    />
    <div
      v-if="!articleIsLoading && !articleIsErrored && article.comments"
      class="Comments"
    >
      <div class="Title Comments-Title">
        Комментарии
      </div>
      <BaseComment
        v-for="comment in article.comments"
        :key="comment.id"
        :id="comment.id"
        :authorId="comment.user.id"
        :author="comment.user.name"
        :photo="comment.user.photo"
        :timestamp="comment.timestamp"
        :text="comment.text"
        :className="'Comments-Comment'"
        @reply="reply(comment.id)"
      />
    </div>
    <AddComment
      v-if="!articleIsLoading && !articleIsErrored && isAuth"
      ref="addComment"
    />
  </main>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

const BaseArticle = () =>
  import(/* webpackChunkName: "baseArticle" */ "@/components/BaseArticle.vue");
const BaseComment = () =>
  import(/* webpackChunkName: "comment" */ "@/components/BaseComment.vue");
const AddComment = () =>
  import(/* webpackChunkName: "addComment" */ "@/components/AddComment.vue");

export default {
  name: "Article",

  components: {
    BaseArticle,
    BaseComment,
    AddComment
  },

  computed: {
    ...mapGetters([
      "blogInfo",
      "isAuth",
      "article",
      "articleIsLoading",
      "articleIsErrored",
      "commentParent",
      "commentText"
    ])
  },

  methods: {
    ...mapActions(["getArticle"]),
    ...mapMutations(["replyOnComment", "updateCommentText"]),

    reply: function(commentId) {
      this.replyOnComment(commentId);

      const intro = `<strong>${this.commentParent.user.name}</strong>, `;
      if (
        this.commentParent &&
        !this.commentText.startsWith(intro.trimRight())
      ) {
        this.updateCommentText(intro);
      }

      this.$refs.addComment.focus();
    }
  },

  created() {
    this.getArticle(this.$route.params.id);
  },

  metaInfo() {
    return {
      title:
        this.article && this.article.title
          ? `${this.article.title} | ${this.blogInfo.title} - ${this.blogInfo.subtitle}`
          : `${this.blogInfo.title} - ${this.blogInfo.subtitle}`
    };
  }
};
</script>

<style lang="scss">
.Article {
  margin-top: 15px;
}

.Comments {
  &-Title {
    margin-bottom: 25px;
  }

  &-Comment {
    margin-bottom: 30px;
  }
}
</style>
